"use strict";

import * as React from "react";
import PropTypes from "prop-types";
import CheckBox from "../../../controls/CheckBox.jsx";
import { getIntegerFromEvent } from "../../../utilities/EventsHelper";
import Role from "../../../entities/Role";

const UserProduct = props => {

    const roles = props.productRoles.filter(r => r.isActive);

    const _handleProductAssignedClick = (e) => {
        const roleId = props.userRoleId;
        const roleName = props.productRoles.find(r => r.id === props.userRoleId).name;
        const assigned = e.target.checked;
        props.selectProduct(assigned, props.productId);
    };

    const _handleRoleChanged = (e) => {
        if (!props.assigned) return;
        const roleId = getIntegerFromEvent(e);
        const roleName = props.productRoles.find(r => r.id === roleId).name;
        props.selectRole(props.productId, roleId, roleName);
    };

    return (
        <div id={`UserProduct${props.productId}`} className="col-md-12">
            <div className="col-md-4">
                <CheckBox id={`cbUserProduct${props.productId}`}
                    checked={props.assigned}
                    onChange={_handleProductAssignedClick}
                    title={props.productName}/>
            </div>

            <div className="col-md-3 rolesSelect">

                <select id="ddlProduct"
                    style={{ width:"160px" }}
                    className="picker-hollow"
                    value={props.userRoleId}
                    onChange={_handleRoleChanged}>
                    {
                        roles.map((role) => { return (<option key={role.id} value={role.id}>{role.name}</option>); })
                    }
                </select>
            </div>
        </div>
    );
};

UserProduct.propTypes = {
    assigned: PropTypes.bool.isRequired,
    userRoleId: PropTypes.number.isRequired,
    productId: PropTypes.number.isRequired,
    productName: PropTypes.string.isRequired,
    productRoles: PropTypes.arrayOf(PropTypes.instanceOf(Role)).isRequired,
    selectProduct: PropTypes.func,
    selectRole: PropTypes.func
};

export default UserProduct;
